import cn from "app/utils/classnames";
import { useEffect, useState } from "react";

interface VideoEmbedProps {
  slug: string;
  autoplay?: boolean;
  muted?: boolean;
  subtitles?: boolean;
  showDetails?: boolean;
  startTime?: number;
  endTime?: number;
  className?: string;
}

export default function VideoEmbed({
  slug,
  autoplay = false,
  muted=false,
  subtitles = false,
  showDetails = false,
  startTime = undefined,
  endTime = undefined,
  className = undefined,
}: VideoEmbedProps) {
  // Client-only iframe pattern to prevent hydration errors
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  // TODO: None of my attempts to solve the hydration error worked.
  // It doesn't seem to affect the output though.
  
  // Strip the provided url to just the slug
  let videoUrl = `https://embed.ted.com/talks/${slug}`;
  videoUrl += subtitles ? "?subtitles=true" : "?subtitles=false";
  videoUrl += muted ? "&muted=true" : "&muted=false";
  videoUrl += autoplay ? "&autoplay=true" : "";
  videoUrl += startTime ? `&t=${startTime}` : "";
  videoUrl += endTime ? `&end=${endTime}` : "";
  videoUrl += showDetails ? `&showDetails=true` : "";

  return (
    <div
      className={cn(
        "border border-black",
        "flex flex-col justify-center items-center",
        "overflow-hidden",
        className,
      )}
      suppressHydrationWarning
    >
      {mounted ? (
        <iframe
          className={"w-full h-full block"}
          src={videoUrl}
          allow="autoplay; fullscreen"
          scrolling="no"
        />
      ) : (
        <div className="w-full h-40 lg:h-60" />
      )}
    </div>
  );
}
